export type RcmTableParams = {
  page: number;
  pageSize: number;
  search: string;
  processId: string;
  controlId: string;
  frequency: string;
  controlType: string;
  significance: string;
  riskCategory: string;
  sortKey: string | null;
  sortDir: 'asc' | 'desc';
  // Scopes the list by sox_controls.source ("manual" | "imported"). The
  // "Imported" tab on the RCM page sets this to "imported"; the default
  // Process tab leaves it empty for back-compat.
  source?: string;
  auditYearId?: string;
};

export type RcmAllTableParams = {
  page: number;
  pageSize: number;
  search: string;
  classificationFilter: string;
  soxCycleId: string;
  domainCode: string;
  systemId: string;
  riskCategory: string;
  auditYearId?: string;
};

export const rcmQueryKeys = {
  all: ['rcm-matrix'] as const,
  table: (p: RcmTableParams) => [...rcmQueryKeys.all, 'list', p] as const,
  allTable: (p: RcmAllTableParams) => [...rcmQueryKeys.all, 'all', p] as const,
};
